<script setup>
/**
 * FormHeader
 * The primary toolbar for form views. Provides navigation context,
 * action buttons for record creation, and save triggers.
 */
import {computed} from 'vue'
import {useFormStore} from '@/stores/form'
import FormAddBtn from './FormAddBtn'
import FormDisplayTitle from './FormDisplayTitle'
import ShowSiteTreeBtn from '@/common/ShowSiteTreeBtn'
import FormSaveBtn from './FormSaveBtn'
import FormSaveCloseBtn from './FormSaveCloseBtn'

const props = defineProps({
    formId: {
        type: String,
        required: true
    },
    showAddBtn: Boolean,
    showSaveBtn: Boolean,
    showSaveAndCloseBtn: Boolean
})

// Dynamic Pinia Form Store Helper
const formStore = computed(() => useFormStore(props.formId))

// --- Computed ---

const tableName = computed(() => formStore.value.tableName)

const id = computed(() => formStore.value.id)

const show = computed(() => props.showAddBtn)

// --- Methods ---

const formScrollTop = (e) => {
    // Logic remains placeholder as per original todo
}
</script>

<template>
    <header class="d-flex border-bottom" @click="formScrollTop">
        <div class="flex-fill d-flex align-items-center">
            <ShowSiteTreeBtn
                :table-name="tableName"
                :id="id"
                :site-tree-id="'siteTreeOffcanvas'"
            />

            <FormAddBtn v-if="show" :form-id="formId"/>

            <FormDisplayTitle :form-id="formId"/>
        </div>

        <FormSaveBtn
            v-if="showSaveBtn"
            :form-id="formId"
            class="rounded-0"
        />

        <FormSaveCloseBtn
            v-if="showSaveAndCloseBtn"
            :form-id="formId"
        />
    </header>
</template>